/**
 * @typedef {ReturnType<import("src/services/state").createAppState>} State
 */
import { createContext } from "preact";
import { useContext } from "preact/hooks";

/** @type import("preact").Context<State> */
export const AppState = createContext(null);

/** @returns {State} */
export function useAppContext() {
  return useContext(AppState);
}
